import * as React from 'react';
import { LabelConfig } from 'ui';
import styles from './label.scss';

interface LabelProps{
  label: LabelConfig;
  classNames?: string;
  htmlFor?: string;
  selectSymbol?: JSX.Element;
  }

/**
 * Display the label if configured as visible
 *
 * @internal
 */

export const Label = ({ label, classNames, selectSymbol, ...rest } : LabelProps) =>
(label && label.visible) ? 
  <label {...rest} className={`${classNames} label`}>
    {selectSymbol}
    {label.text}
    {!!label.colon && <span className={styles.withColon}>:</span>} 
  </label> 
  : null;
